import axios from 'axios'
import swal from 'sweetalert'

import { handleErrorFetchingData } from '../../../functions/errorHandling'
import getServerURL from '../../../functions/getServerURL'

let defaultState = {
  phase: 1,
  title: '',
  submissionDate: new Date(),
  fteSow: 'FTE',
  status: '',
  duration: '',
  notes: '',
  professionalFees: '',
  passThroughCosts: '',
  selectedProjects: [],
  selectedClient: [],
  clientManager: [],
  proposalLead: [],
  analysts: [],
  newProposalMetadataValues: [],
  googleDriveLink: '',
  category: 'Full Proposal',
}

export default function manageProposalCreation(state = defaultState, action) {
  switch (action.type) {
    case "CHANGE_PROPOSAL_CREATION_PHASE":
      return { ...state, phase: action.payload }
    case "HANDLE_PROPOSAL_CREATION_CHANGE":
      return { ...state, ...action.payload }
    case "UPDATE_NEW_PROPOSAL_CREATION_METADATA_VALUES":
      let newProposalMetadataValues = [...state.newProposalMetadataValues]
      newProposalMetadataValues = newProposalMetadataValues.filter(value => {
        return value.metadata !== action.payload.type
      })
      newProposalMetadataValues = [...newProposalMetadataValues, ...action.payload.values]
      return { ...state, newProposalMetadataValues }
    case "CANCEL_PROPOSAL_CREATION":
      return defaultState
    default:
      return state
  }
}

export const handleProposalCreationChange = (name, value) => {
  let payload
  if (name === 'selectedClient' && Array.isArray(value) && value.length === 0) {
    payload = { selectedClient: [], selectedProjects: [] }
  } else {
    payload = { [name]: value }
  }
  return { type: "HANDLE_PROPOSAL_CREATION_CHANGE", payload }
}

export const changeProposalMetadataValues = (type, values) => {
  return { type: "UPDATE_NEW_PROPOSAL_CREATION_METADATA_VALUES", payload: { type, values } }
}

export const cancelProposalCreation = () => {
  return { type: "CANCEL_PROPOSAL_CREATION" }
}

export const changePhase = (phase) => {
  return { type: "CHANGE_PROPOSAL_CREATION_PHASE", payload: phase }
}

export const saveProposal = (proposal, history) => {
  swal({
    text: "Creating proposal...",
    icon: require("../../../static/images/spinner.gif"),
    button: false
  })

  return (dispatch) => {
    const newProposal = {
      title: proposal.title,
      submission_date: new Date(proposal.submissionDate).toJSON().split("T")[0],
      status: proposal.status,
      fte_sow: proposal.fteSow,
      proposed_duration: proposal.duration,
      professional_fees: Number(proposal.professionalFees),
      pass_through_costs: Number(proposal.passThroughCosts),
      projects: proposal.selectedProjects.map(project => project.url),
      client: proposal.selectedClient[0].url,
      client_manager: proposal.clientManager[0].url,
      proposal_lead: proposal.proposalLead[0].url,
      analysts: proposal.analysts.map(analyst => analyst.url),
      // proposal_metadata_values: proposal.newProposalMetadataValues.map(value => value.url),
      g_drive_link: proposal.googleDriveLink,
      category: proposal.category,
      notes: proposal.notes,
      created_by: {},
    }

    axios({
      method:"POST",
      url:`${getServerURL()}proposals/`,
      headers:{"Authorization": "Bearer " + localStorage.getItem("token")},
      data: { ...newProposal }
    })
    .then(response => {
      swal({
        title: "Success",
        text: `Proposal ${proposal.title} has been created`,
        icon: "success",
        button: "Continue",
      })
      .then(() => {
        history.push(`/proposals/${response.data.id}`)
        dispatch(cancelProposalCreation())
      })
    })
    .catch(error => {
      let message
      if (error.response && error.response.data && typeof error.response.data === 'object') {
        message = "The following error(s) occurred: "

        Object.keys(error.response.data).forEach((key, index) => {
          const messageTitle = key.split('_')
          .map(word => word[0].toUpperCase() + word.slice(1))
          .join(' ')

          let errorMessage = `${messageTitle}: ${error.response.data[key].join(", ")}`

          if (index < error.response.data.length - 1) {
            errorMessage += ", "
          }

          message += errorMessage
        })
      } else {
        message = "There was an error creating your proposal"
      }
      handleErrorFetchingData(error, message)
    })
  }
}



// WEBPACK FOOTER //
// ./src/routes/proposals/reducers/manageProposalCreation.js